import {IComponentOptions} from "angular";
import {CreateExternalUnitRequest} from "../../model/CreateExternalUnitRequest";
import {CparService} from "../../cpar/cpar.service";

class ExternalUnitController {
    public createExternalUnitRequest: CreateExternalUnitRequest;
    public showErrors: boolean;
    public error: string;
    private processing: boolean;
    private unit: any;

    /* @ngInject */
    constructor(
        private $log: ng.ILogService,
        private cparService: CparService) {
    }

    public $onInit() {
        this.$log.debug("ExternalUnitController.$onInit()");
        this.showErrors =  false;
    }

    public cancel() {
        this.unit.willCreate = false;
    }

    public createExternalUnit() {
        this.processing = true;
        this.$log.info("createExternalUnit() %o", this.unit);
        this.error = "";
        this.showErrors = false;
        this.cparService.createExternalUnit(this.unit)
            .then((results: any) => {
                this.$log.log(results);
                this.unit.externalUnitId = results._links.externalUnitId;
                this.unit.willCreate = false;
                this.$log.debug("Unit created: %o", results);
            })
            .catch((error) => {
                this.showErrors = true;
                this.error = error.data.message;
                this.$log.error(error);
            })
            .finally(() => {
                this.processing = false;
            });
    }
}

export const ExternalUnitComponent: IComponentOptions = {
    bindings: {
        unit: "="
    },
    controller: ExternalUnitController,
    controllerAs: "vm",
    template: require("./externalUnit.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/assessment/create-precedent-modal/externalUnit.component.ts